import diseases from '../../repo/diseases';

import DiseaseSearchResult from "./result";
import Anchor from '../../navigation/anchor';

import router from '../../navigation/router';
import template from './index.tpl';
import './index.css';

export default DomClass(template, async function Search() {
	const _t = this;

	// arguments for disease.find()
	this.query = this.query ? this.query : '';
	this.get_after = this.get_after ? this.get_after : null;
	this.index = this.index ? this.index : null;
	this.limit = this.limit || 10;

	this.form.onsubmit = function() {
		router.navigate('?search/q=' + _t.query);
		return false;
	}

	let searchResults = await diseases.find(this);
	console.log('searched', {query: this.query, limit: this.limit});
	console.log('recieved', searchResults);
	console.log('next', searchResults.next);
	console.log('next()',
		typeof(searchResults.next) == 'function' ?
			await searchResults.next()
		: null
	);
	this.results = searchResults.map(d => DiseaseSearchResult(d));

	if (searchResults.next) {
		this.next = new Anchor({
			href: '?search/q=' + searchResults.next.query
				+ '/a=' + searchResults.next.get_after,
			body: 'Next'
		});
	} else {
		this.next = 'End of results.';
	}

});
